import { cn } from "@/lib/cn";
import { formatMoney } from "@/lib/format";
import type { Money } from "@/lib/types";

type Props = {
  amount: Money;
  compareAt?: Money | null;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeMap = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-xl",
};

export default function Price({ amount, compareAt, size = "md", className }: Props) {
  const onSale =
    compareAt != null && Number(compareAt.amount) > Number(amount.amount);

  return (
    <span className={cn("inline-flex items-baseline gap-2", sizeMap[size], className)}>
      <span
        className={cn(
          "font-medium",
          onSale && "text-[color:var(--color-primary)]",
        )}
      >
        {formatMoney(amount)}
      </span>
      {onSale && (
        <span className="text-[color:var(--color-muted)] line-through text-[0.85em]">
          {formatMoney(compareAt)}
        </span>
      )}
    </span>
  );
}
